// extracted by mini-css-extract-plugin
export default {"tile-row":"LLL7","tileRow":"LLL7","webhook-tile":"ESbH","webhookTile":"ESbH","name":"wvxU","description":"I2TF","logo":"ofK2"};